import {loader} from './loader'

export default function wishlist() {
  function ifEmptyWishList(){
    const wrapper = $('.wishlist-items-wrapper');

    if (wrapper.length !== 0) {
      const rowsCount = wrapper.find('.study-item-row').length;
      if (rowsCount === 0) {
        wrapper.html('<p>Wishlist is empty.</p><p>If you see a school that interests you, click on the heart and it will be added to your Wishlist.<br/>Use your wishlist to compare different schools and click "APPLY" when you are ready to apply!</p>')
        wrapper.find('.apply-to-all').remove()
      }
    }
  }

  $(document).on('click', '.wishlist-link', function(e){
    e.preventDefault();
    let $this = $(this),
      product_id = $this.data('product-id');

    $this.prop("disabled", true);

    $.ajax({
      url: window.glob_obj.ajaxurl,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'aw_wishlist_toggle',
        _ajax_nonce: window.glob_obj.aw_wishlist_toggle_nonce,
        product_id: product_id
      },
      beforeSend: function(){
        loader.show()
      },
      success: function (response) {
        loader.hide()
        $this.prop("disabled", false);

        if (response.status === 'noauth') {
          $('body').append(response.modal);

          $('.modal').modal().on('hidden.bs.modal', function (e) {
            $(this).remove();
          });
        }

        if (response.status === 'success') {
          $this.toggleClass('selected')

          if ($this.hasClass('wishlist-remove-link')) {
            $this.closest('.study-item-row').remove()
            ifEmptyWishList()
          }
        }

      },
      error: function(error){
        loader.hide()
        $this.prop("disabled", false);
        console.log(error);
      }
    });
  });
}